"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncate = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var isArray_1 = tslib_1.__importDefault(require("lodash/isArray"));
function truncate(items, maxLength) {
    if (!items) {
        return [];
    }
    if (isArray_1.default(items)) {
        // only get first two attributes
        return items.slice(0, maxLength);
    }
    return [items];
}
exports.truncate = truncate;
//# sourceMappingURL=truncate.js.map